<div class="card-simple">
  <div class="card-inner">
    <div class="card-head">
      <div class="payment-source">
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'alipay'" svgIcon="card-alipay" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'american_express'" svgIcon="card-amex" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'american express'" svgIcon="card-amex" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'AmericanExpress'" svgIcon="card-amex" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'amex'" svgIcon="card-amex" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'diners'" svgIcon="card-diners" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'discover'" svgIcon="card-discover" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'elo'" svgIcon="card-elo" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'hypercard'" svgIcon="card-hypercard" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'jcb'" svgIcon="card-jcb" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'maestro'" svgIcon="card-maestro" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'master'" svgIcon="card-master" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'mastercard'" svgIcon="card-master" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'paypal'" svgIcon="card-paypal" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'unionpay'" svgIcon="card-unionpay" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'verve'" svgIcon="card-verve" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.accountType.toLowerCase() === 'visa'" svgIcon="card-visa" class="custom-mat-icon ico-card ico-size ico-std"></mat-icon>
        <mat-icon *ngIf="paymentMethod.type.toLowerCase() === 'ach'" svgIcon="ico-bank" class="custom-mat-icon ico-card ico-size ico-sm"></mat-icon>
        <label class="typo subheading-1 condensed fw400 label-last4">Ending in {{ paymentMethod.accountNumber }}</label>
      </div>
    </div>
    <div class="card-content">
      <!-- Name On Card -->
      <div class="content-inner">
        <div class="block" *ngIf="paymentMethod.accountName">
          <label class="typo note fw400 condensed label-headline">Name on Card</label>
          <label class="typo body-1 fw400">{{ paymentMethod.accountName}}</label>
        </div>
        <div class="block" *ngIf="paymentMethod.type === 'card'">
          <label class="typo note fw400 condensed label-headline">Expiration Date</label>
          <label class="typo body-1 fw400">{{ paymentMethod.expDate }}</label>
        </div>
      </div>
      <!-- Gateway -->
      <div class="content-inner">
        <div class="block">
          <label class="typo note fw400 condensed label-headline">Payment Gateway</label>
          <label class="typo body-1 fw400">{{ gateway.keyName | titlecase }}</label>
        </div>
        <div class="block">
          <label class="typo note fw400 condensed label-headline">Gateway Display Name</label>
          <label class="typo body-1 fw400">{{ gateway.name }}</label>
        </div>
      </div>
      <!-- Billing Address -->
      <div class="content-inner">
        <div class="block">
          <label class="typo note fw400 condensed label-headline">Billing Address</label>
          <label class="typo body-1 fw400">
            <span *ngIf="paymentMethod.billingAddress.street1 !== ''">{{ paymentMethod.billingAddress.street1 }}</span> <span *ngIf="paymentMethod.billingAddress.street2 !== ''">{{ paymentMethod.billingAddress.street2 }}</span></label>
          <label class="typo body-1 fw400">
            <span *ngIf="paymentMethod.billingAddress.city !== ''">{{ paymentMethod.billingAddress.city }}, </span>
            <span *ngIf="paymentMethod.billingAddress.state !== ''">{{ paymentMethod.billingAddress.state }}, </span>
            <span *ngIf="paymentMethod.billingAddress.zip !== ''">{{ paymentMethod.billingAddress.zip }}</span>
          </label>
          <label class="typo body-1 fw400">
            <span *ngIf="paymentMethod.billingAddress.country.name !== ''">{{ paymentMethod.billingAddress.country.name }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
